import styled from 'styled-components';

import { utils } from '@frontend/partviewer';

const { formatLengthProp } = utils;

const Wrapper = styled.div`
  color: inherit;
  font-size: 13px;
  margin-bottom: 10px;
  text-align: right;
  width: 200px;
`;

const Title = styled.span`
  font-weight: 700;
  margin-bottom: 5px;
`;

const EntryWrapper = styled.div``;

const EntryTitle = styled.span`
  margin-right: 5px;
`;

const EntryValue = styled.span``;

const SelectorCumulativeInfoComponent = ({
  cumulativeInfo,
  displayScale,
  displayUnits,
  nativeUnits,
  dimensionalPrecision,
}) => {
  return cumulativeInfo && (cumulativeInfo.area || cumulativeInfo.length) ? (
    <Wrapper>
      <Title>Cumulative Selection</Title>
      {cumulativeInfo.area > 0 && (
        <EntryWrapper>
          <EntryTitle>Face Area:</EntryTitle>
          <EntryValue>
            {formatLengthProp({
              value: cumulativeInfo.area,
              order: 2,
              displayUnits,
              nativeUnits,
              dimensionalPrecision,
              displayScale,
            })}
          </EntryValue>
        </EntryWrapper>
      )}
      {cumulativeInfo.length > 0 && (
        <EntryWrapper>
          <EntryTitle>Edge Length:</EntryTitle>
          <EntryValue>
            {formatLengthProp({
              value: cumulativeInfo.length,
              order: 1,
              displayUnits,
              nativeUnits,
              dimensionalPrecision,
              displayScale,
            })}
          </EntryValue>
        </EntryWrapper>
      )}{' '}
    </Wrapper>
  ) : null;
};

export default SelectorCumulativeInfoComponent;
